import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const toIso = (d) => new Date(d).toISOString().replace(/\.\d+Z$/, "");

// Fetch historical quakes from GeoNet FDSN via our backend.
export function useHistoricalQuakes(start, end, { minMag = 3.0, enabled = true } = {}) {
  const [state, setState] = useState({
    quakes: [],
    max_magnitude: null,
    latest: null,
    loading: false,
    error: null,
  });

  useEffect(() => {
    if (!enabled || !start || !end) return undefined;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    axios
      .get(`${API}/quakes/range`, {
        params: { start: toIso(start), end: toIso(end), min_mag: minMag },
      })
      .then((res) => {
        if (cancelled) return;
        setState({
          quakes: res.data.quakes || [],
          max_magnitude: res.data.max_magnitude,
          latest: res.data.latest,
          loading: false,
          error: null,
        });
      })
      .catch((e) => {
        if (cancelled) return;
        setState((s) => ({ ...s, loading: false, error: e.message || String(e) }));
      });
    return () => {
      cancelled = true;
    };
  }, [start && new Date(start).getTime(), end && new Date(end).getTime(), minMag, enabled]);

  return state;
}
